// import { useQuery } from "@tanstack/react-query";
// import { MenusAPI, RolePermissionsAPI } from "api";
// import { useFetchMenus } from "hooks/useFetchMenu";
// import { useFetchRolesPermissions } from "hooks/useFetchPermissions";
// import { useEffect, useState } from "react";
// import { Spinner } from "react-bootstrap";

// export const useFilterAndSortMenuItems = () => {
//   const menuData = JSON.parse(localStorage.getItem("menus"));

//   console.log(menuData);

//   const userInfo = JSON.parse(localStorage.getItem("user"));
//   let roleId = userInfo ? userInfo.role : 0;

//   const { data: permissionsResponse, isLoading: isLoadingPermissions } =
//     useFetchRolesPermissions(roleId);

//   let permissionsData = permissionsResponse?.data.data ?? [];

//   // Filter permissions by role
//   const rolePermissions = permissionsData?.filter(
//     (permission) => permission.roleId === roleId
//   );

//   // Create a map of menuId to permissions
//   const menuPermissions = rolePermissions?.reduce((acc, permission) => {
//     acc[permission.menuId] = permission;
//     return acc;
//   }, {});

//   console.log("menu Permissions", rolePermissions);

//   // Separate parent and child menu items
//   const parents = menuData?.filter((menu) => menu.parentId === 0);
//   const children = menuData?.filter((menu) => menu.parentId !== 0);

//   // Map parent IDs to their children
//   const parentIdToChildren = parents?.reduce((acc, parent) => {
//     acc[parent.id] = children?.filter((child) => child.parentId === parent.id);
//     return acc;
//   }, {});

//   console.log("Parent Id to Children", parentIdToChildren);

//   // Filter out parents whose children all have allowView set to false
//   const visibleParents = parents?.filter((parent) => {
//     const children = parentIdToChildren[parent.id];
//     return children?.some((child) => menuPermissions[child.id]?.allowView);
//     // return children?.some((child) => menuPermissions[child.id]?.allowView);
//   });

//   console.log("Visible Parents", visibleParents);

//   // Filter children to only include those that are allowed to be viewed
//   const visibleChildren = children?.filter(
//     (child) => menuPermissions[child.id]?.allowView
//   );

//   // Map parent IDs to their visible children
//   const parentIdToVisibleChildren = visibleParents?.reduce((acc, parent) => {
//     acc[parent.id] = visibleChildren?.filter(
//       (child) => child.parentId === parent.id
//     );
//     return acc;
//   }, {});

//   // Sort the parent items
//   const sortedParents = visibleParents?.sort(
//     (a, b) => a.sortOrder - b.sortOrder
//   );

//   // Nest the child items under their respective parents
//   const nestedMenuItems = sortedParents?.map((parent) => ({
//     ...parent,
//     children: parentIdToVisibleChildren[parent.id].sort(
//       (a, b) => a.sortOrder - b.sortOrder
//     ),
//   }));

//   console.log("Nested Menu Items", nestedMenuItems);

//   // nestedMenuItems.push({
//   //   name: "OOH",
//   //   active: true,
//   //   icon: "table",
//   //   children: [
//   //     {
//   //       name: "Inventory",
//   //       url: "/ooh/inventory",
//   //       exact: true,
//   //       active: true,
//   //     },
//   //   ],
//   // });

//   // console.log(nestedMenuItems);

//   return {
//     nestedMenuItems: nestedMenuItems ?? [],
//     // isLoading
//   };
// };
// ======================================Without Permissions===========================================

// import { useState } from "react";

// export const useFilterAndSortMenuItems = () => {
//   const menuData = JSON.parse(localStorage.getItem("menus"));

//   // console.log(roleId);

//   // Separate parent and child menu items
//   const parents = menuData?.filter((menu) => menu.parentId === 0);
//   const children = menuData?.filter((menu) => menu.parentId !== 0);

//   // Map parent IDs to their children
//   const parentIdToChildren = parents?.reduce((acc, parent) => {
//     acc[parent.id] = children?.filter((child) => child.parentId === parent.id);
//     return acc;
//   }, {});

//   // console.log("Parent Id to Children", parentIdToChildren);

//   // Include all parents and their respective children
//   const visibleParents = parents;

//   // Map parent IDs to their visible children
//   const parentIdToVisibleChildren = visibleParents?.reduce((acc, parent) => {
//     acc[parent.id] = parentIdToChildren[parent.id] ?? [];
//     return acc;
//   }, {});

//   // Sort the parent items
//   const sortedParents = visibleParents?.sort(
//     (a, b) => a.sortOrder - b.sortOrder
//   );

//   // Nest the child items under their respective parents
//   const nestedMenuItems = sortedParents?.map((parent) => ({
//     ...parent,
//     children: parentIdToVisibleChildren[parent.id].sort(
//       (a, b) => a.sortOrder - b.sortOrder
//     ),
//   }));

//   // console.log("Nested Menu Items", nestedMenuItems);

//   return {
//     nestedMenuItems: nestedMenuItems ?? [],
//   };
// };
// ======================================Without Permissions End===========================================

// import { useState, useEffect } from "react";
// import { usePermission } from "../context/PermissionContext";

// export const useFilterAndSortMenuItems = () => {
//   const { hasPermission } = usePermission();
//   const [nestedMenuItems, setNestedMenuItems] = useState([]);

//   useEffect(() => {
//     const menuData = JSON.parse(localStorage.getItem("menus")) || [];

//     // Separate parents and children
//     const parents = menuData.filter((menu) => menu.parentId === 0);
//     const children = menuData.filter((menu) => menu.parentId !== 0);

//     // Filter out menus the user cannot view
//     const filteredParents = parents.filter((menu) =>
//       hasPermission(menu.id, "allowView")
//     );
//     const filteredChildren = children.filter((menu) =>
//       hasPermission(menu.id, "allowView")
//     );

//     console.log("Filtered Parents", filteredParents);
//     console.log("Filtered Children", filteredChildren);

//     // Map parent IDs to their visible children
//     const parentIdToChildren = filteredParents.reduce((acc, parent) => {
//       acc[parent.id] = filteredChildren.filter(
//         (child) => child.parentId === parent.id
//       );
//       return acc;
//     }, {});

//     // Sort parents and children by sort order
//     const sortedParents = filteredParents.sort(
//       (a, b) => a.sortOrder - b.sortOrder
//     );

//     const nestedItems = sortedParents.map((parent) => ({
//       ...parent,
//       children: (parentIdToChildren[parent.id] || []).sort(
//         (a, b) => a.sortOrder - b.sortOrder
//       ),
//     }));

//     setNestedMenuItems(nestedItems);
//   }, [hasPermission]);

//   return { nestedMenuItems };
// };

// import { useState, useEffect } from "react";
// import { usePermission } from "../context/PermissionContext";

// export const useFilterAndSortMenuItems = () => {
//   const { hasPermission, loading } = usePermission();
//   const [nestedMenuItems, setNestedMenuItems] = useState([]);

//   useEffect(() => {
//     const menuData = JSON.parse(localStorage.getItem("menus")) || [];
//     // Separate parent and child menus
//     const parents = menuData.filter((menu) => menu.parentId === 0);
//     const children = menuData.filter((menu) => menu.parentId !== 0);

//     // Filter children that have permission to view
//     const filteredChildren = children.filter((menu) =>
//       hasPermission(menu.id, "allowView")
//     );

//     // Find parent IDs that have at least one child with permission
//     const parentIdsWithVisibleChildren = new Set(
//       filteredChildren.map((child) => child.parentId)
//     );

//     // Filter parents: Include if they have permission OR at least one child is viewable
//     const filteredParents = parents.filter(
//       (parent) =>
//         hasPermission(parent.id, "allowView") ||
//         parentIdsWithVisibleChildren.has(parent.id)
//     );

//     // Map parent IDs to their visible children
//     const parentIdToChildren = filteredParents.reduce((acc, parent) => {
//       acc[parent.id] = filteredChildren.filter(
//         (child) => child.parentId === parent.id
//       );
//       return acc;
//     }, {});

//     // Sort parents and children by sort order
//     const sortedParents = filteredParents.sort(
//       (a, b) => a.sortOrder - b.sortOrder
//     );

//     const nestedItems = sortedParents.map((parent) => ({
//       ...parent,
//       children: (parentIdToChildren[parent.id] || []).sort(
//         (a, b) => a.sortOrder - b.sortOrder
//       ),
//     }));

//     setNestedMenuItems(nestedItems);
//   }, [hasPermission]);

//   return { nestedMenuItems, loading };
// };
import { useState, useEffect } from "react";
import { usePermission } from "../context/PermissionContext";

export const useFilterAndSortMenuItems = () => {
  const { hasPermission, loading } = usePermission();
  const [nestedMenuItems, setNestedMenuItems] = useState([]);

  useEffect(() => {
    // const menuData = JSON.parse(localStorage.getItem("menus")) || [];

    const menuData = JSON.parse(localStorage.getItem("menus") || "[]")?.map(
      (item) => ({
        ...item,
        parentId: Number(item.parentId), // force to number
      })
    );

    // Build a map from parentId -> children
    const menuMap = menuData?.reduce((acc, menu) => {
      if (!acc[menu.parentId]) acc[menu.parentId] = [];
      acc[menu.parentId].push(menu);
      return acc;
    }, {});

    const sortByOrder = (items) =>
      items?.sort((a, b) => a.sortOrder - b.sortOrder);

    // Recursively build the menu tree up to 3 levels
    const buildMenuTree = (menus, level = 1) => {
      return sortByOrder(menus)
        .map((menu) => {
          const children = menuMap[menu.id] || [];
          const filteredChildren = buildMenuTree(children, level + 1);

          const isVisible =
            hasPermission(menu.id, "allowView") || filteredChildren.length > 0;

          if (!isVisible) return null;

          return {
            ...menu,
            children: filteredChildren,
          };
        })
        .filter(Boolean);
    };

    const topLevelMenus = menuMap[0] || [];

    const result = buildMenuTree(topLevelMenus);
    setNestedMenuItems(result);
  }, [hasPermission]);

  return { nestedMenuItems, loading };
};
